module.exports = __webpack_public_path__ + "img/download-small-white.11890fd6.svg";